
import { Input, Box } from "@chakra-ui/react";
import { useRef } from "react";

/**
 * Provides a file upload button.
 * Does not do the actual upload! That is done by onUpload from the parent component.
 * 
 * TODO drag and drop support
 * 
 * @param {Object} props
 * @param {function} props.onUpload - callback for when a file is uploaded
 * @returns 
 */
export default function FileUpload({ onUpload, children, accept, multiple, ...args }) {
	const fileInputRef = useRef(null);

	return (
		<><Input
			type="file"
			multiple={multiple}
			position="absolute"
			top="0"
			left="0"
			display="none"
			opacity="0"
			cursor="pointer"
			ref={fileInputRef}
			onChange={(e) => onUpload(e.target.files)}
			accept={accept}			
		/>
			<Box cursor="pointer" onClick={() => fileInputRef.current.click()} {...args}>{children}</Box>
		</>
	);
}

